import React from "react";
import { MdWrongLocation } from "react-icons/md";
import { LuClock10 } from "react-icons/lu";
import { FaArrowRight } from "react-icons/fa";
import { IoMdArrowRoundForward } from "react-icons/io";
import { Link } from "react-router-dom";

const TourSections = () => {
  return (
    <>
      <section className="section-with-120px-margin">
        <div className="container">
          <div className="_2-column-block-top">
            <div
              className="main-block w-dyn-list"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
            >
              <div role="list" className="_3-column-grid w-dyn-items">
                <div role="listitem" className="w-dyn-item">
                  <div className="tour-card">
                    <div className="tour-thumbnail-wrapper">
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232614/pexels-basbrandwijk-6047748_lqo9gy_ws4nyo.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 46vw, 314.9375px"
                        srcSet="
                                        https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232614/pexels-basbrandwijk-6047748_lqo9gy_ws4nyo.jpg
                                    "
                        className="image-height-205px"
                      />
                      <Link
                        to="/elizabeth"
                        data-w-id="12cd3259-7543-7843-5e9d-aa58d6914661"
                        className="book-now-button w-inline-block"
                        style={{
                          transform:
                            "translate3d(0px, 40px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                          opacity: 0,
                        }}
                      >
                        <div className="button-text-wrapper">
                          <div className="default-text">Book Now</div>
                          <div className="hover-text">Book Now</div>
                        </div>
                        <div className="button-icon">
                          <IoMdArrowRoundForward />
                        </div>
                      </Link>
                      <div
                        className="tour-hover"
                        style={{ height: "0%" }}
                      ></div>
                    </div>
                    <div className="tour-body">
                      <div className="tour-body-top">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <MdWrongLocation />

                            <br />
                          </div>
                          <p className="_20px-text">Southwest, Uganda</p>
                        </div>
                        <Link to="/elizabeth" className="w-inline-block">
                          <h3 className="_24px-text hover-link">
                            Queen Elizabeth NP
                          </h3>
                        </Link>
                        <div className="horizontal-left-center-4px-gap">
                          <img
                            src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9fb38c02b3a4101d26ec8_star.svg"
                            loading="lazy"
                            alt=""
                            className="image-16px"
                          />
                          <p className="_20px-text">4.3</p>
                        </div>
                      </div>
                      <div className="_1px-divider"></div>
                      <div className="destination-footer">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <br />
                          </div>
                          <LuClock10 />
                          <p className="_14px-text">2 days</p>
                        </div>
                        <div className="w-layout-hflex horizontal-left-bottom-10px-gap">
                          <p className="_14px-text">From</p>
                          <div className="text-merge">
                            <div className="_24px-text-600">$</div>
                            <div className="_24px-text-600">100</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="listitem" className="w-dyn-item">
                  <div className="tour-card">
                    <div className="tour-thumbnail-wrapper">
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232623/pexels-ajmal-kabeer-454815513-18229345_kxxleo_rztngo.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 46vw, 314.9375px"
                        srcSet="
                                        https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232623/pexels-ajmal-kabeer-454815513-18229345_kxxleo_rztngo.jpg
                                    "
                        className="image-height-205px"
                      />
                      <Link
                        to="/machison"
                        data-w-id="12cd3259-7543-7843-5e9d-aa58d6914661"
                        href="/tour/horizon-hoppers"
                        className="book-now-button w-inline-block"
                        style={{
                          transform:
                            "translate3d(0px, 40px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                          opacity: 0,
                        }}
                      >
                        <div className="button-text-wrapper">
                          <div className="default-text">Book Now</div>
                          <div className="hover-text">Book Now</div>
                        </div>
                        <div className="button-icon">east</div>
                      </Link>
                      <div
                        className="tour-hover"
                        style={{ height: "0%" }}
                      ></div>
                    </div>
                    <div className="tour-body">
                      <div className="tour-body-top">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <MdWrongLocation />

                            <br />
                          </div>
                          <p className="_20px-text">Northwestern, Uganda</p>
                        </div>
                        <Link to="/machison" className="w-inline-block">
                          <h3 className="_24px-text hover-link">
                            Machison Falls
                          </h3>
                        </Link>
                        <div className="horizontal-left-center-4px-gap">
                          <img
                            src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9fb38c02b3a4101d26ec8_star.svg"
                            loading="lazy"
                            alt=""
                            className="image-16px"
                          />
                          <p className="_20px-text">4.9</p>
                        </div>
                      </div>
                      <div className="_1px-divider"></div>
                      <div className="destination-footer">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <br />
                          </div>
                          <LuClock10 />
                          <p className="_14px-text">5 days</p>
                        </div>
                        <div className="w-layout-hflex horizontal-left-bottom-10px-gap">
                          <p className="_14px-text">From</p>
                          <div className="text-merge">
                            <div className="_24px-text-600">$</div>
                            <div className="_24px-text-600">100</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* KIDEPO */}

                <div role="listitem" className="w-dyn-item">
                  <div className="tour-card">
                    <div className="tour-thumbnail-wrapper">
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232652/pexels-david-atkins-11679899-6233523_mlf0fa_bfjjxe.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 46vw, 314.9375px"
                        srcSet="
                                        https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232652/pexels-david-atkins-11679899-6233523_mlf0fa_bfjjxe.jpg
                                    "
                        className="image-height-205px"
                        style={{
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      />
                      <Link
                        to="/kidepo"
                        data-w-id="12cd3259-7543-7843-5e9d-aa58d6914661"
                        href="/tour/venture-vista"
                        className="book-now-button
                        w-inline-block"
                        style={{
                          transform:
                            "translate3d(0px, 40px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                          opacity: 0,
                        }}
                      >
                        <div className="button-text-wrapper">
                          <div className="default-text">Book Now</div>
                          <div className="hover-text">Book Now</div>
                        </div>
                        <div className="button-icon">
                          <IoMdArrowRoundForward />
                        </div>
                      </Link>
                      <div
                        className="tour-hover"
                        style={{ height: "0%", width: "226px" }}
                      ></div>
                    </div>
                    <div className="tour-body">
                      <div className="tour-body-top">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <MdWrongLocation />

                            <br />
                          </div>
                          <p className="_20px-text">Northwestern, Uganda</p>
                        </div>
                        <Link to="/kidepo" className="w-inline-block">
                          <h3 className="_24px-text hover-link">
                            Kidepo Valley
                          </h3>
                        </Link>
                        <div className="horizontal-left-center-4px-gap">
                          <img
                            src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9fb38c02b3a4101d26ec8_star.svg"
                            loading="lazy"
                            alt=""
                            className="image-16px"
                          />
                          <p className="_20px-text">4.4</p>
                        </div>
                      </div>
                      <div className="_1px-divider"></div>
                      <div className="destination-footer">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <br />
                          </div>
                          <LuClock10 />
                          <p className="_14px-text">7 days</p>
                        </div>
                        <div className="w-layout-hflex horizontal-left-bottom-10px-gap">
                          <p className="_14px-text">From</p>
                          <div className="text-merge">
                            <div className="_24px-text-600">$</div>
                            <div className="_24px-text-600">100</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/*  */}
                <div role="listitem" className="w-dyn-item">
                  <div className="tour-card">
                    <div className="tour-thumbnail-wrapper">
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232664/pexels-chamane-rogers-475046922-28668053_gibbmm_jp6jkl.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 46vw, 314.9375px"
                        srcSet="
                                        https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232664/pexels-chamane-rogers-475046922-28668053_gibbmm_jp6jkl.jpg
                                    "
                        className="image-height-205px"
                      />
                      <Link
                        to="/elgon"
                        data-w-id="12cd3259-7543-7843-5e9d-aa58d6914661"
                        href="/tour/wayfarer-wanderlust"
                        className="book-now-button w-inline-block"
                        style={{
                          transform:
                            "translate3d(0px, 40px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                          opacity: 0,
                        }}
                      >
                        <div className="button-text-wrapper">
                          <div className="default-text">Book Now</div>
                          <div className="hover-text">Book Now</div>
                        </div>
                        <div className="button-icon">
                          <IoMdArrowRoundForward />
                        </div>
                      </Link>
                      <div
                        className="tour-hover"
                        style={{ height: "0%" }}
                      ></div>
                    </div>
                    <div className="tour-body">
                      <div className="tour-body-top">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <MdWrongLocation />

                            <br />
                          </div>
                          <p className="_20px-text">Masaba Road, Uganda</p>
                        </div>
                        <Link to="/elgon" className="w-inline-block">
                          <h3 className="_24px-text hover-link">
                            Mt. Elgon NP
                          </h3>
                        </Link>
                        <div className="horizontal-left-center-4px-gap">
                          <img
                            src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9fb38c02b3a4101d26ec8_star.svg"
                            loading="lazy"
                            alt=""
                            className="image-16px"
                          />
                          <p className="_20px-text">4.2</p>
                        </div>
                      </div>
                      <div className="_1px-divider"></div>
                      <div className="destination-footer">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <br />
                          </div>
                          <LuClock10 />
                          <p className="_14px-text">4 days</p>
                        </div>
                        <div className="w-layout-hflex horizontal-left-bottom-10px-gap">
                          <p className="_14px-text">From</p>
                          <div className="text-merge">
                            <div className="_24px-text-600">$</div>
                            <div className="_24px-text-600">100</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="listitem" className="w-dyn-item">
                  <div className="tour-card">
                    <div className="tour-thumbnail-wrapper">
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232630/pexels-francesco-ungaro-1238272_givrl7_ysevkx.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 46vw, 314.9375px"
                        srcSet="
                                        https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232630/pexels-francesco-ungaro-1238272_givrl7_ysevkx.jpg
                                    "
                        className="image-height-205px"
                      />
                      <Link
                        to="/mburo"
                        data-w-id="12cd3259-7543-7843-5e9d-aa58d6914661"
                        href="/tour/odyssey-outfitters"
                        className="book-now-button w-inline-block"
                        style={{
                          transform:
                            "translate3d(0px, 40px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                          opacity: 0,
                        }}
                      >
                        <div className="button-text-wrapper">
                          <div className="default-text">Book Now</div>
                          <div className="hover-text">Book Now</div>
                        </div>
                        <div className="button-icon">
                          <IoMdArrowRoundForward />
                        </div>
                      </Link>
                      <div
                        className="tour-hover"
                        style={{ height: "0%" }}
                      ></div>
                    </div>
                    <div className="tour-body">
                      <div className="tour-body-top">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <MdWrongLocation />

                            <br />
                          </div>
                          <p className="_20px-text">Western region,Uganda</p>
                        </div>
                        <Link
                          to="/mburo"
                          href="/tour/odyssey-outfitters"
                          className="w-inline-block"
                        >
                          <h3 className="_24px-text hover-link">
                            Lake Mburo NP
                          </h3>
                        </Link>
                        <div className="horizontal-left-center-4px-gap">
                          <img
                            src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9fb38c02b3a4101d26ec8_star.svg"
                            loading="lazy"
                            alt=""
                            className="image-16px"
                          />
                          <p className="_20px-text">4.5</p>
                        </div>
                      </div>
                      <div className="_1px-divider"></div>
                      <div className="destination-footer">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <br />
                          </div>
                          <LuClock10 />
                          <p className="_14px-text">3 days</p>
                        </div>
                        <div className="w-layout-hflex horizontal-left-bottom-10px-gap">
                          <p className="_14px-text">From</p>
                          <div className="text-merge">
                            <div className="_24px-text-600">$</div>
                            <div className="_24px-text-600">100</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="listitem" className="w-dyn-item">
                  <div className="tour-card">
                    <div className="tour-thumbnail-wrapper">
                      <img
                        src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232606/pexels-hsapir-5416742_pbvlvh_p4mcuc.jpg"
                        loading="lazy"
                        alt=""
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 95vw, (max-width: 991px) 46vw, 314.9375px"
                        srcSet="
                                        https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232606/pexels-hsapir-5416742_pbvlvh_p4mcuc.jpg
                                    "
                        className="image-height-205px"
                      />
                      <Link
                        to="/mahinga"
                        data-w-id="12cd3259-7543-7843-5e9d-aa58d6914661"
                        href="/tour/globe-trotters"
                        className="book-now-button w-inline-block"
                        style={{
                          transform:
                            "translate3d(0px, 40px, 0px) scale3d(1.2, 1.2, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                          opacity: 0,
                        }}
                      >
                        <div className="button-text-wrapper">
                          <div className="default-text">Book Now</div>
                          <div className="hover-text">Book Now</div>
                        </div>
                        <div className="button-icon">
                          <IoMdArrowRoundForward />
                        </div>
                      </Link>
                      <div
                        className="tour-hover"
                        style={{ height: "0%" }}
                      ></div>
                    </div>
                    <div className="tour-body">
                      <div className="tour-body-top">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <MdWrongLocation />

                            <br />
                          </div>
                          <p className="_20px-text">South of Kisoro, Uganda</p>
                        </div>
                        <Link
                          to="/mahinga"
                          href="/tour/globe-trotters"
                          className="w-inline-block"
                        >
                          <h3 className="_24px-text hover-link">
                            Mgahinga Gorilla
                          </h3>
                        </Link>
                        <div className="horizontal-left-center-4px-gap">
                          <img
                            src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9fb38c02b3a4101d26ec8_star.svg"
                            loading="lazy"
                            alt=""
                            className="image-16px"
                          />
                          <p className="_20px-text">4.8</p>
                        </div>
                      </div>
                      <div className="_1px-divider"></div>
                      <div className="destination-footer">
                        <div className="w-layout-hflex horizontal-left-center-10px-gap">
                          <div className="icon">
                            <br />
                          </div>
                          <LuClock10 />
                          <p className="_14px-text">4 days</p>
                        </div>
                        <div className="w-layout-hflex horizontal-left-bottom-10px-gap">
                          <p className="_14px-text">From</p>
                          <div className="text-merge">
                            <div className="_24px-text-600">$</div>
                            <div className="_24px-text-600">100</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="navigation"
                aria-label="List"
                className="w-pagination-wrapper"
              ></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TourSections;
